export class AddUserType {
    static IMPORT = "import";
    static MANUAL = "manual";
    static INVITE = "invite";
    static ADD_EXISTING = "add_existing";

    type: string;

    constructor(type: string) {
        this.type = type;
    }
}

export type AddUserTypeValue = "import" | "manual" | "invite" | "add_existing";
